import {DostavistaCarrierUiExtension} from "./dostavistaCarrierUiExtension";

/**
 * Яндекс: как Достависта по контактам (только основной телефон, подсказка, перенос доп. номеров в комментарии к адресу),
 * без поля «короткое сообщение курьеру» и без привязки vehicleTypeId к тарифу.
 */
export class YandexCarrierUiExtension extends DostavistaCarrierUiExtension {
    isCourierMessageAvailable() {
        return false;
    }

    onTariffSelected({changeParam}) {
        changeParam('vehicleTypeId', null);
    }
}



// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/carrierExtensions/yandexCarrierUiExtension.js